module.exports = __webpack_public_path__ + "img/qualityJewellery.12f3c47.webp";